@use '@helsenorge/designsystem-react/scss/spacers' as spacers;

.feedbackbutton {
  &--fill {
    background: var(--color-help-graphics);
    color: var(--color-action-text-light-normal);

    &:hover {
      background: var(--color-help-graphics-plus2);
      box-shadow: 0 0 0 spacers.getSpacer(3xs) var(--color-help-graphics-plus2);
    }

    &:active {
      background: var(--color-help-graphics-plus1);
      box-shadow: 0 0 0 spacers.getSpacer(3xs) var(--color-help-graphics-plus1);
    }
  }

  &--outline,
  &--floating,
  &--borderless {
    outline-color: var(--color-help-border);
    color: var(--color-help-graphics);

    &:hover {
      background: var(--color-help-background-transparent-onlight-hover);
    }

    &:active {
      background: var(--color-help-background-transparent-onlight-active);
    }

    & > * {
      color: var(--color-help-graphics) !important;
    }

    & svg {
      fill: var(--color-help-graphics);
    }
  }

  &__floating-wrapper {
    box-shadow: 0 4px 4px 0 rgb(0 0 0 / 25%);

    &:hover,
    &:focus,
    &:active {
      box-shadow: 0 4px 4px 0 rgb(0 0 0 / 25%);
    }
  }
}
